import { render, staticRenderFns } from "./EventStartDateGenre.vue?vue&type=template&id=9bbda052"
import script from "./EventStartDateGenre.vue?vue&type=script&lang=js"
export * from "./EventStartDateGenre.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports